import { render, staticRenderFns } from "./createDivisionModal.vue?vue&type=template&id=5fadd183&scoped=true&"
import script from "./createDivisionModal.vue?vue&type=script&lang=js&"
export * from "./createDivisionModal.vue?vue&type=script&lang=js&"
import style0 from "./createDivisionModal.vue?vue&type=style&index=0&id=5fadd183&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fadd183",
  null
  
)

export default component.exports